import { CircularProgress, Typography } from '@material-ui/core'
import { FlexHorizontal, IBoard, LoadMask, Spacer, useToasts } from '@vestaboard/installables'
import { ITemplateMessage, MessageTemplateForm } from '../components/MessageTemplateForm'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'

import { Link } from '../../link'
import { tryAsync } from '../../../utils/tryAsync'
import { useCreateTemplateMessage } from '../hooks/useCreateTemplateMessage'
import { useGetMessageLazy } from '../../message-v2/hooks/useGetMessage'

export const CreateMessage = () => {
  const history = useHistory()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const messageId = searchParams.get('messageId') || null
  const { addToast } = useToasts()
  const [createTemplateMessage, { loading: saving }] = useCreateTemplateMessage()
  const [fetchMessage, { data: messageData, loading: loadingMessageData }] = useGetMessageLazy()
  const [templateMessage, setTemplateMessage] = useState<null | ITemplateMessage>(null)

  useEffect(() => {
    if (messageId) {
      fetchMessage({
        variables: {
          id: messageId
        }
      })
    }
  }, [fetchMessage, messageId])

  useEffect(() => {
    if (messageData && messageData.message.__typename === 'MessageV2') {
      setTemplateMessage({
        message: {
          id: messageData.message.id,
          text: messageData.message.text,
          characters: messageData.message.characters as IBoard,
          tags: messageData.message.tags || []
        }
      })
    }
  }, [messageData])

  return (
    <>
      <FlexHorizontal>
        <Link to='/message-templates'>
          <Typography variant='h4'>Template Messages</Typography>
        </Link>
        <Typography variant='h4'> / Create</Typography>
      </FlexHorizontal>
      <Spacer size='large' />
      {loadingMessageData ? (
        <CircularProgress />
      ) : (
        <MessageTemplateForm
          key={templateMessage?.message?.id}
          templateMessage={templateMessage || undefined}
          onCreate={async templateMessage => {
            const { result } = await tryAsync(() =>
              createTemplateMessage({
                variables: {
                  input: {
                    categoryId: templateMessage.categoryId || '',
                    messageId: templateMessage.message?.id || '',
                    isFeatured: templateMessage.isFeatured || false
                  }
                }
              })
            )

            if (result && result.data?.createTemplateMessage.__typename === 'TemplateMessageV2') {
              history.push(`/message-templates/message/${result.data?.createTemplateMessage.id}`)
            } else {
              console.warn(result)
              addToast('There was an error saving your template message', {
                appearance: 'error'
              })
            }
          }}
        />
      )}
      {saving ? <LoadMask /> : null}
    </>
  )
}
